module.exports = __webpack_public_path__ + "static/media/falsemirror.0c35eec6.png";